import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Chip,
  IconButton,
  Button,
  LinearProgress,
  Divider,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Icon } from "@iconify/react/dist/iconify.js";
import dayjs from "dayjs";
import { useCallback } from "react";
import JobsSelectionArea from "./JobsSelectionArea";
import ExtendDateMenu from "./ExtendDateMenu";
import { useNavigate } from "react-router-dom";
const AccordionComponent = ({
  goal,
  selectedGoalIds = [],
  setSelectedGoalIds,
  expandedGoalsIds = [],
  setExpandedGoalsIds,
  bulkOrSingleArchiveFunction,
  bulkOrSingleGetApprovalFunction,
  dispatchData,
  adminView,
  user
}) => {
  const navigate = useNavigate();
  const handleExpandClick = useCallback((event, goalId) => {
    event.stopPropagation();
    setExpandedGoalsIds((prev) => {
      return prev.includes(goalId)
        ? prev.filter((id) => id !== goalId)
        : [...prev, goalId];
    });
  }, []);

  const adminGoalAndJobEditNavigation = () => {
    const passingObject = {
      goal: goal,
      adminView:adminView,
      user:user
    };
    navigate("/Appraisal-Management/add-goal", { state: passingObject });
  };

  const jobActivityDisabled =
    goal?.extendedGoalStatus == 7 || goal.extendedGoalStatus == 3;

  return (
    <Paper
      elevation={3}
      sx={{
        border: "1px solid #ccc",
        overflow: "hidden",
      }}
    >
      <Accordion
        expanded={expandedGoalsIds.includes(goal?.goal_id)}
        sx={{
          boxShadow: "none",
          "&::before": { display: "none" },
        }}
      >
        {/* ACCORDION HEADER START >>>>>>>>>>>>> */}
        <AccordionSummary
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            backgroundColor: "white",
            //  pb:-10
          }}
        >
          <Box width="100%">
            <Box
              sx={{
                gap: 1,
                display: "flex",
                alignItems: { xs: "start", md: "center" },
                justifyContent: { xs: "start", md: "space-between" },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <Box>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {goal?.goal_name}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <Button
                  disableElevation
                  disableRipple
                  disableFocusRipple
                  sx={{
                    // cursor: 'url("https://cdn-icons-png.flaticon.com/24/599/599502.png") 6 6, default',
                    cursor: "not-allowed !important",
                    fontSize: "0.65rem",
                    borderRadius: "4px",
                    bgcolor: "#26a0fc",
                    color: "white",
                    pointerEvents: "auto",
                    boxShadow: "none",
                    minWidth: "108px",
                    height: "26px",
                    "&:hover": {
                      bgcolor: "#1e88e5",
                    },
                  }}
                >
                  {`${goal?.completedPercentage}% Complete`}
                </Button>

                {goal.extendedGoalStatus == 1 ? (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    sx={{
                      border: "1px solid #26a0fc",
                      cursor: "not-allowed !important",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      bgcolor: "rgba(38, 159, 252, 0.11)",
                      color: " #26a0fc",
                      pointerEvents: "auto",
                      boxShadow: "none",
                      minWidth: "108px",
                      height: "26px",
                    }}
                  >
                    {`In Progress`}
                  </Button>
                ) : goal.extendedGoalStatus == 5 ? (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    sx={{
                      border: "1px solid #eed490",
                      cursor: "not-allowed !important",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      bgcolor: "rgba(255, 136, 0, 0.14)",
                      color: "orange",
                      pointerEvents: "auto",
                      boxShadow: "none",
                      minWidth: "108px",
                      height: "26px",
                    }}
                  >
                    {`Pending For Approval`}
                  </Button>
                ) : goal.extendedGoalStatus == 3 ? (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    sx={{
                      border: "1px solid lightgreen",
                      cursor: "not-allowed !important",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      bgcolor: "rgba(47, 255, 0, 0.14)",
                      color: "green",
                      pointerEvents: "auto",
                      boxShadow: "none",
                      minWidth: "108px",
                      height: "26px",
                    }}
                  >
                    {`Completed`}
                  </Button>
                ) : goal.extendedGoalStatus == 6 ? (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    sx={{
                      border: "1px solid #ee9090",
                      cursor: "not-allowed !important",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      bgcolor: "rgba(255, 25, 0, 0.14)",
                      color: "red",
                      pointerEvents: "auto",
                      boxShadow: "none",
                      minWidth: "108px",
                      height: "26px",
                    }}
                  >
                    {`Rejected`}
                  </Button>
                ) : goal.extendedGoalStatus == 7 ? (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    sx={{
                      border: "1px solid #ee9090",
                      cursor: "not-allowed !important",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      bgcolor: "rgba(255, 25, 0, 0.14)",
                      color: "red",
                      pointerEvents: "auto",
                      boxShadow: "none",
                      minWidth: "108px",
                      height: "26px",
                    }}
                  >
                    {`Cancelled`}
                  </Button>
                ) : goal.extendedGoalStatus == 4 ? (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    sx={{
                      border: "1px solid #ee9090",
                      cursor: "not-allowed !important",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      bgcolor: "rgba(255, 25, 0, 0.14)",
                      color: "red",
                      pointerEvents: "auto",
                      boxShadow: "none",
                      minWidth: "108px",
                      height: "26px",
                    }}
                  >
                    {`Overdue`}
                  </Button>
                ) : (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple
                    sx={{
                      border: "1px solid #ee9090",
                      cursor: "not-allowed !important",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      bgcolor: "rgba(255, 25, 0, 0.14)",
                      color: "red",
                      pointerEvents: "auto",
                      boxShadow: "none",
                      minWidth: "108px",
                      height: "26px",
                    }}
                  >
                    {`Draft`}
                  </Button>
                )}

                {goal.extendedGoalStatus == 7 && (
                  <Button
                    disabled={jobActivityDisabled}
                    sx={{
                      boxShadow: "none",
                      fontSize: "0.65rem",
                      borderRadius: "4px",
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "white",
                      },
                    }}
                    variant={"outlined"}
                    color="primary"
                    onClick={() =>
                      bulkOrSingleGetApprovalFunction({
                        ids: [goal?.last_extend_id],
                        action: "single",
                      })
                    }
                    size="small"
                    startIcon={<Icon icon="formkit:submit" />}
                  >
                    Re Submit
                  </Button>
                )}

                {dayjs(goal?.goal_last_extended_end_date).isBefore(dayjs()) &&
                  goal.extendedGoalStatus !== 3 &&
                  goal.extendedGoalStatus !== 7 && (
                    <Box>
                      <ExtendDateMenu
                        goalId={goal?.goal_id}
                        dispatchData={dispatchData}
                        disabled={jobActivityDisabled}
                        lastDate={goal?.goal_last_extended_end_date}
                      />
                    </Box>
                  )}

                {adminView && (
                  <Button
                    sx={{
                       minWidth: "108px",
                      boxShadow: "none",
                      fontSize: "0.65rem",
                      borderRadius: "4px",
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "white",
                      },
                    }}
                    variant={"outlined"}
                    color="primary"
                    onClick={adminGoalAndJobEditNavigation}
                    size="small"
                    startIcon={<Icon icon="raphael:edit" />}
                  >
                    Edit Goal
                  </Button>
                )}

                {/* NO NEED TO SEE THE SINGLE ARCHIVE FOR USERS */}
                {false && (
                  <Button
                    sx={{
                      fontSize: "0.65rem",
                      borderRadius: "4px",
                      boxShadow: "none",
                      minWidth: "100px",
                      "&:hover": {
                        bgcolor: "primary.main",
                        color: "white",
                      },
                    }}
                    variant={"outlined"}
                    color="primary"
                    onClick={() =>
                      bulkOrSingleArchiveFunction({
                        ids: [goal?.goal_id],
                        action: "single",
                        archive: goal?.goal_status ? true : false,
                      })
                    }
                    size="small"
                    startIcon={<Icon icon="ic:sharp-archive" />}
                  >
                    {goal?.goal_status ? "Archive" : "Unarchive"}
                  </Button>
                )}

                <Box>
                  <Checkbox
                    checked={selectedGoalIds.includes(goal?.goal_id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedGoalIds((prev) => [...prev, goal?.goal_id]);
                      } else {
                        setSelectedGoalIds((prev) =>
                          prev.filter((id) => id !== goal?.goal_id)
                        );
                      }
                    }}
                    disableRipple
                    sx={{
                      p: 0,
                      m: 0,
                      color: " #2f72b3", // outline color when unchecked
                      "&.Mui-checked": {
                        color: "#2f72b3", // outline + tick color when checked
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 20,
                      },
                    }}
                  />
                </Box>

                {/* Only expand when icon is clicked */}
                <IconButton
                  onClick={(e) => handleExpandClick(e, goal.goal_id)}
                  size="small"
                >
                  <ExpandMoreIcon />
                </IconButton>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              {/* Progress + percentage label */}
              <Box sx={{ width: "95.5%", mt: 0.5 }}>
                <LinearProgress
                  variant="determinate"
                  value={goal?.completedPercentage ?? 0}
                  sx={{
                    height: 4,
                    borderRadius: "4px",
                    backgroundColor: "#eee",
                    "& .MuiLinearProgress-bar": {
                      backgroundColor:
                        goal?.completedPercentage >= 90
                          ? "#4fff00"
                          : goal?.completedPercentage >= 50
                          ? "#ffd600"
                          : "#ff0000",
                    },
                  }}
                />
                <Box
                  sx={{
                    mt: 0.5,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "0.8rem",
                      fontWeight: "bold",
                      color: "#555",
                    }}
                  >
                    {goal?.completedPercentage ?? 0}%
                  </Typography>
                  {/* Start and End Dates */}
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#888",
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                        },
                      }}
                    >
                      Start Date :{" "}
                      {dayjs(goal?.goal_start_date).format("DD-MM-YYYY")}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#888",
                        fontSize: {
                          xs: "0.7rem",
                          sm: "0.8rem",
                        },
                      }}
                    >
                      End Date :{" "}
                      {dayjs(goal?.goal_last_extended_end_date).format(
                        "DD-MM-YYYY"
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                mt: 1,
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                alignItems: "center ",
              }}
            >
              {goal?.tags?.map((tag, index) => (
                <Chip
                  key={`${tag?.id}-${index}`}
                  label={tag?.name}
                  size="small"
                  sx={{
                    color: tag?.color || "black",
                    fontSize: {
                      xs: "0.6rem",
                      sm: "0.7rem",
                    },
                    fontWeight: 600,
                    p: 1,
                    display: tag?.name ? "inline-flex" : "none",
                  }}
                />
              ))}
            </Box>
          </Box>
        </AccordionSummary>
        {/* ACCORDION HEADER END <<<<<<<<<<<<<<<< */}
        {/* ACCORDION BODY START >>>>>>>>>>>>>>>>>> */}
        <AccordionDetails>
          <Box
            sx={{
              maxHeight: 450,
              overflowY: "auto",
              border: "1px solid #ddd",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
              p: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#444",
                lineHeight: "1.5 !important",
                letterSpacing: "0.3px",
                textAlign: "left",
                cursor: "pointer",
                fontSize: {
                  xs: "0.8rem",
                  sm: "0.85rem",
                },
                fontWeight: 400,
                transition: "color 0.2s ease",
                "&:hover": {
                  color: "#222",
                },
                wordBreak: "break-word",
                hyphens: "auto",
                maxWidth: "100%",
                display: "block",
              }}
            >
              {goal?.goal_description}
            </Typography>

            <Divider sx={{ mt: 1 }} />
            {/* JOBS LISTING AND SELECTION BOX AREA START */}
            <JobsSelectionArea
              goal={goal}
              dispatchData={dispatchData}
              jobActivityDisabled={jobActivityDisabled}
              adminView={adminView}
            />
            {/* JOBS LISTING AND SELECTION BOX AREA END */}
          </Box>
        </AccordionDetails>
        {/* ACCORDION BODY END <<<<<<<<<<<<<<<<<<<<<<<< */}
      </Accordion>
    </Paper>
  );
};

export default React.memo(AccordionComponent);
